import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import FontKeys from '../FontKeys';
import gameData from '../gameData';

export default class TrackBall extends Phaser.GameObjects.Container {
  constructor(scene, value, color) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.isHit = false;
    this.circleSize = gameData.BALL_SIZE;
    this.defaultStyle = color;
    this.defaultValue = value;

    this.circleShape = ABCyaPhaser.Images.addImage(0, 0, `ball-${this.defaultStyle}`, this);

    const circleScale = gameData.BALL_SIZE / (this.circleShape.getBounds().width - 5);
    this.circleShape.scaleX = circleScale;
    this.circleShape.scaleY = circleScale;

    this.setBallValue(value);
  }

  changeBall(value, colorId) {
    this.setBallColor(colorId);
    this.setBallValue(value);
  };

  revertBall() {
    this.changeBall(this.defaultValue, this.defaultStyle);
  };

  setBallColor(style) {
    this.circleShape.setFrame(`ball-${style}`);
  };

  setBallValue(value) {
    this.numValue = value;
    if (this.numContainer) this.numContainer.destroy();
    this.numContainer = ABCyaPhaser.Text.addText(0, 0, 26, '0x515152', FontKeys._odin_roundedregular, value.toString(), this);
  };
}